<template>
 <v-card flat>
     <v-toolbar flat color="grey lighten-3">
      <v-toolbar-title>{{ $t('app.label.test') }}</v-toolbar-title>
    </v-toolbar>
    <ViewBar :hidden="true"></ViewBar>
    <Annotate :testParams="testParams"></Annotate>

     </v-card>
</template>

<script>
import Annotate from "../components/test/Annotate";
import ViewBar from "../components/viewbar/ViewBar";
import { decodeParams } from "../routes/pathParams"

export default {
  components: {
    Annotate,
    ViewBar,
  },
  data() {
    return {
      testParams: null
    }
  },
  mounted: function () {
    this.testParams = decodeParams(this.$route.params.testParams);

  },
};
</script>
